'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the best Nabhik Samaj Vadhu Var Suchak?', answer: 'MarathiVadhuVarSuchak.com is the best Nabhik Samaj Vadhu Var Suchak Kendra in Maharashtra.' },
  { question: 'How to join the Nabhik Samaj Vadhu Var WhatsApp Group Link?', answer: 'No! Due to the strict privacy policy, MarathiVadhuVarSuchak.com does not have a WhatsApp Group Link to join.' },
  { question: 'Which is the trusted Nabhik Samaj Vadhu Var Kolhapur?', answer: "For Kolhapur-based Nabhik Samaj Vadhu Var, 'Marathi Vadhu Var Suchak' is the trusted matrimony for free online registration." },
  { question: 'Which is the trusted Nabhik Samaj Satara Vadhu Var Suchak?', answer: 'MarathiVadhuVarSuchak.com Marathi matrimonial is the most trusted Nabhik Samaj Vadhu Var Suchak Mandal for Satara-based Vadhu Var.' },
  { question: 'Which is the best Nabhik Samaj Matrimony in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com is the most trusted matrimony brand for Nabhik Samaj in Maharashtra.' },
  { question: 'Which is the best Nabhik Samaj Thane region-based matrimony?', answer: 'For the Thane region-based Nabhik Samaj Vadhu Var, MarathiVadhuVarSuchak.com is the trusted brand to register for free.' },
  { question: 'How to join the Nabhik Samaj WhatsApp group?', answer: 'Because of the privacy policy, MarathiVadhuVarSuchak.com Marathi matrimony does not have any Nabhik Samaj WhatsApp group to join.' },
  { question: 'How to search the Nabhik Samaj Bandra based Nabhik Samaj Matrimony?', answer: ' For online registration from anywhere, MarathiVadhuVarSuchak.com is the best option for Bandra-based Nabhik Samaj brides and grooms.' },
  { question: 'How to search the Nabhik Samaj Mumbai based Vadhu Var profiles?', answer: 'Mumbai-based Nabhik Samaj Vadhu Var should visit MarathiVadhuVarSuchak.com matrimony for free registration.' },
  { question: 'How to search the Nabhik Samaj Vadhu profiles online?', answer: 'To search the Nabhik Samaj Vadhu profiles online, visit MarathiVadhuVarSuchak.com Marathi matrimony site.' },
  { question: 'How to search the Nabhik Samaj Nabhik Vadhu photo with the matrimony profile?', answer: 'To search for the Nabhik Samaj Nabhik Vadhu photo with the matrimony profile, register free on MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search the Nabhik Samaj Nashik based Vadhu Var profiles?', answer: 'To search the Nabhik Samaj Nashik-based Vadhu Var profiles, you have to register for free on MarathiVadhuVarSuchak.com.' },
  { question: 'Which is the best Nabhik Samaj Maharashtra based matrimony? ', answer: 'MarathiVadhuVarSuchak.com is the best Maharashtra based Nabhik Samaj matrimony.' },
  { question: 'How to search the Nabhik Samaj Jalgaon based Vadhu Var profiles?', answer: 'You can search Jalgaon-based Nabhik Samaj Vadhu Var profiles through the MarathiVadhuVarSuchak.com portal.' },
  { question: 'How to search the Nabhik Samaj Vadhu Var Mumbai?', answer: 'To search the Nabhik Samaj Vadhu Var from Mumbai city, visit a trusted MarathiVadhuVarSuchak.com matrimony portal.' },
  { question: 'How to join the Nabhik Samaj WhatsApp group link?', answer: 'No! We do not have any Nabhik Samaj WhatsApp group link to join due to the privacy policy.' },
  { question: 'Which is the best Nabhik Samaj Vadhu Var Nashik?', answer: 'For the Nashik-based Nabhik Samaj Vadhu Var, the MarathiVadhuVarSuchak.com mobile app is the best option for free registration.' },
  { question: 'How to search for Nhavi Samaj Var profile online?', answer: "To search for Nhavi Samaj grooms' profiles online, you have to register for free online through the MarathiVadhuVarSuchak.com mobile app." },
  { question: 'How to search the Nhavi Samaj Surname List online?', answer: 'You can search the Nhavi Samaj Vadhu Var profiles with the surname option on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to attend Nahvi Samaj Vadhu Var Melava in Maharashtra?', answer: 'MarathiVadhuVarSuchak.com organizes Vadhu Var Melava at different locations. Keep visiting the site for the latest updates.' },
  { question: 'Which is the best Nahvi Matrimony Pune?', answer: 'For Pune-based Nahvi Samaj Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted option.' },
  { question: 'How to do the Nhavi matrimony login online?', answer: 'First, sign up for free on MarathiVadhuVarSuchak.com, and then you can log in anytime online.' },
  { question: 'How to search the Nahvi Matrimony Grooms online?', answer: "To search the Nahvi grooms' profiles online, visit MarathiVadhuVarSuchak.com matrimony." },
  { question: 'How to search the Nahvi Matrimony Brides profiles?', answer: "To search the Nahvi Samaj brides' profiles online, you have to register for free through MarathiVadhuVarSuchak.com Marathi matrimony." },
  { question: 'Which is the trusted Marathi Nhavi Matrimony in Maharashtra?', answer: "For Marathi Nhavi Samaj Vadhu Var, 'Marathi Vadhu Var Suchak' is the most trusted Marathi Nhavi Matrimony in Maharashtra." },
  { question: 'Which is the best Nabhik Matrimony in Nagpur?', answer: "For the Nagpur-based Nabhik Samaj brides and grooms, the 'Marathi Vadhu Var Suchak' mobile app is the most trusted brand." },
  { question: 'Which is the best Nhavi Vadhu Var Suchak Mandal Pune?', answer: "For Pune city based peoples, 'Marathi Vadhu Var Suchak' mobile app is the best option." },
  { question: 'How to search the Nabhik Vadhu Sangli?', answer: 'To search for the Sangli-based Nabhik Vadhu, first register free through the MarathiVadhuVarSuchak.com site.' },
  { question: 'How to join the Nabhik Vadhu Var Suchak WhatsApp group link?', answer: 'We do not have any WhatsApp group link to join due to the strict privacy policy.' },
  { question: 'How to search the divorced Nabhik Vadhu photo with profile?', answer: 'Visit MarathiVadhuVarSuchak.com Matrimony site to search the divorced Nabhik Vadhu photo with profiles.' },
  { question: 'How to search the Nabhik Samaj Nabhik Vadhu photo with matrimony profile?', answer: 'To search the Nabhik Samaj Vadhu photo with matrimony profile, you have to register free through MarathiVadhuVarSuchak.com portal.' },
  { question: 'Which is the trusted Nabhik Vadhu Var Suchak Mandal Nashik?', answer: 'For Nashik city based Nabhik Vadhu Var, MarathiVadhuVarSuchak.com matrimony is the trusted brand.' },
  { question: 'Which is the best Nabhik Vadhu Var Suchak Mandal in Mumbai?', answer: 'In Mumbai city, MarathiVadhuVarSuchak.com matrimony is the best Nabhik Vadhu Var Suchak Mandal.' },
  { question: 'How to search the Divorce Nabhik Vadhu on matrimony?', answer: 'To search the Divorcee Vadhu from Nabhik Samaj, you have register free on MarathiVadhuVarSuchak.com Marathi matrimony.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Nabhik Samaj" },
  { label: "Nabhik Samaj Vadhu Var WhatsApp Group Link" },
  { label: "Nabhik Samaj Vadhu Var Kolhapur" },
  { label: "Nabhik Samaj Satara" },
  { label: "Nabhik Samaj Matrimony" },
  { label: "Nabhik Samaj Thane" },
  { label: "Nabhik Samaj WhatsApp group" },
  { label: "Nabhik Samaj Bandra" },
  { label: "Nabhik Samaj Mumbai" },
  { label: "Nabhik Samaj Vadhu" },
  { label: "Nabhik Samaj Nabhik Vadhu photo" },
  { label: "Nabhik Samaj Vadhu Var" },
  { label: "Nabhik Samaj Nashik" },
  { label: "Nabhik Samaj Maharashtra" },
  { label: "Nabhik Samaj Jalgaon" },
  { label: "Nabhik Samaj Vadhu Var Mumbai" },
  { label: "Nabhik Samaj WhatsApp group link" },
  { label: "Nabhik Samaj Vadhu Var Nashik" },
  { label: "Nhavi Samaj Var" },
  { label: "Nhavi Samaj Surname List" },
  { label: "Nahvi Samaj Vadhu Var Melava" },
  { label: "Nhavi matrimony" },
  { label: "Nahvi Matrimony Pune" },
  { label: "Nhavi matrimony login" },
  { label: "Nahvi Matrimony Grooms" },
  { label: "Nahvi Matrimony Brides" },
  { label: "Marathi Nhavi Matrimony" },
  { label: "Nabhik Matrimony" },
  { label: "Nhavi Vadhu Var Suchak Mandal" },
  { label: "Nahvi Vadhu Var Suchak Mandal Pune" },
  { label: "Nabhik Vadhu Var Suchak" },
  { label: "Nabhik Vadhu Sangli" },
  { label: "Nabhik Vadhu Var Suchak WhatsApp Group Link" },
  { label: "Nabhik Vadhu Var Suchak Mandal" },
  { label: "Divorced Nabhik Vadhu photo" },
  { label: "Nabhik Samaj Nabhik Vadhu Photo" },
  { label: "Nabhik Vadhu Var Suchak Mandal Nashik" },
  { label: "Nabhik Vadhu Var Suchak Mandal in Mumbai" },
  { label: "Divorce Nabhik Vadhu" },
];

export default function NhaviMatrimonyClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="न्हावी (नाभिक) समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="nhavi_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Nahvi Matrimony for Nabhik Communities"
        items={communityServices}
      />

    </div>
  );
}
